// extracted by mini-css-extract-plugin
export default {"container":"jK","productarea":"kK","btn":"lK","promowrapper":"mK","upsellarea":"nK","subtitle":"oK","system":"pK","desc":"qK","cardswrap":"rK","cards":"sK","squareloadingcontainer":"tK","squareloading33":"uK"};
    if(module.hot) {
      // 1743628927465
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  